import { Github, Linkedin, Instagram, MessageCircle, Video } from 'lucide-react';
import { SOCIAL_LINKS } from '../../lib/constants';

export default function Footer() {
  return (
    <footer className="bg-dark-lighter border-t border-neon-blue/20 py-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/images/logo.png" alt="Logo" className="w-10 h-10" />
              <span className="text-xl font-bold neon-text-blue">Mahin Nawawi</span>
            </div>
            <p className="text-gray-400 text-sm">
              Law & Tech in Harmony – Dari Pasal ke Pixel
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-neon-blue font-bold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <a href="#home" className="block text-gray-400 hover:text-neon-blue transition">Beranda</a>
              <a href="#about" className="block text-gray-400 hover:text-neon-blue transition">Tentang</a>
              <a href="#projects" className="block text-gray-400 hover:text-neon-blue transition">Projek</a>
              <a href="#contact" className="block text-gray-400 hover:text-neon-blue transition">Kontak</a>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-neon-green font-bold mb-4">Connect</h3>
            <div className="flex gap-4">
              <a
                href={SOCIAL_LINKS.github}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-neon-blue transition"
              >
                <Github size={24} />
              </a>
              <a
                href={SOCIAL_LINKS.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-neon-blue transition"
              >
                <Linkedin size={24} />
              </a>
              <a
                href={SOCIAL_LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-neon-blue transition"
              >
                <Instagram size={24} />
              </a>
              <a
                href={SOCIAL_LINKS.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-neon-blue transition"
              >
                <Video size={24} />
              </a>
              <a
                href={SOCIAL_LINKS.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-neon-green transition"
              >
                <MessageCircle size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Mahin Utsman Nawawi. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
